import Link from "next/link";

const BreadCrumb = ({ title, text }) => {
  return (
    <div className="">
      {/* <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-inner text-center">
              <h2 className="title">{title}</h2>
              <ul className="page-list">
                <li className="rbt-breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <div className="icon-right">
                    <i className="feather-chevron-right"></i>
                  </div>
                </li>
                <li className="rbt-breadcrumb-item active">{text}</li>
              </ul>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default BreadCrumb;
